import React, { useCallback, useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { FormikContext } from "formik";
import { SectionContent, Loading } from "../../../../components";
import { ResultadoDeSorteiosForm } from "../../../../forms";
import ResultadoImg from "../../../../assets/images/habitacional/ilustracao-homem-comemorando-sorteio.svg";
import { parseISO } from "../../../../utils/dateUtils";
import { useResultadoSorteiosHabitacional } from "../../../../hooks";
import produtosHabitacional from "../../../../config/produtosSorteioHabitacional.json";
import ResultadoSorteiosEmprestimos from "../../../../components/ResultadoSorteiosEmprestimos";

const FormConsultaDeSorteios = ({
  products,
  resultados,
  dataSorteios,
  productId,
  error,
}) => {
  const { setFieldValue, submitForm, values } = useContext(FormikContext);
  const [anoResultado, setAnoResultado] = useState("");

  useEffect(() => {
    const resultadoPrincipal = resultados ? resultados[0] : null;

    if (resultadoPrincipal?.data_extracao) {
      const dataExtracao = parseISO(resultadoPrincipal.data_extracao);
      setAnoResultado(dataExtracao.getFullYear());
    }
  }, [resultados]);

  useEffect(() => {
    const { id, label, value } = {
      ...products.find(({ id: planoId }) => productId === planoId),
    };

    setFieldValue("id", id);
    setFieldValue("produto", { label, value });
  }, [productId, products, setFieldValue, submitForm]);

  useEffect(() => {
    if (values.id) {
      submitForm();
    }
  }, [submitForm, values.id]);

  return (
    <ResultadoSorteiosEmprestimos
      resultados={resultados}
      dataSorteios={dataSorteios}
      anoResultado={anoResultado}
      imgSrc={ResultadoImg}
      imgAlt="Homem comemorando resultado de sorteio"
      error={error}
      setAnoResultado={setAnoResultado}
    />
  );
};

FormConsultaDeSorteios.defaultProps = {
  resultados: null,
  dataSorteios: [],
};

FormConsultaDeSorteios.propTypes = {
  products: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
      id: PropTypes.string.isRequired,
    })
  ).isRequired,
  resultados: PropTypes.arrayOf(Object),
  dataSorteios: PropTypes.arrayOf(PropTypes.string),
  productId: PropTypes.string.isRequired,
  error: PropTypes.bool.isRequired,
};

const ResultadoSorteios = ({ tipoSeguro }) => {
  const {
    resultados,
    getResults,
    dataSorteios,
    loading,
    error,
  } = useResultadoSorteiosHabitacional();

  const buscarResultadoHandle = useCallback(
    ({ id, dataBusca }) => {
      getResults({ id, dataBusca });
    },
    [getResults]
  );

  return (
    <Loading loading={loading}>
      <SectionContent>
        <ResultadoDeSorteiosForm
          form={FormConsultaDeSorteios}
          buscarResultado={buscarResultadoHandle}
          resultados={resultados}
          dataSorteios={dataSorteios}
          onResetForm={() => false}
          products={produtosHabitacional}
          productId={tipoSeguro}
          error={Object.keys({ ...error }).length > 0}
        />
      </SectionContent>
    </Loading>
  );
};

ResultadoSorteios.propTypes = {
  tipoSeguro: PropTypes.string.isRequired,
};

export default ResultadoSorteios;
